import { useEffect } from "react";

export const useSectionObserver = (sectionIds: string[]) => {
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        const visible = entries.find((entry) => entry.isIntersecting);
        if (visible) {
          const newHash = `#${visible.target.id}`;
          if (window.location.hash !== newHash) {
            // eslint-disable-next-line no-restricted-globals
            history.replaceState(null, "", newHash);
          }
        }
      },
      {
        rootMargin: "0px 0px -60% 0px",
        threshold: 0.1,
      }
    );

    sectionIds.forEach((id) => {
      const el = document.getElementById(id);
      if (el) observer.observe(el);
    });

    return () => observer.disconnect();
  }, [sectionIds]);
};
